module.exports = function() {

    showHideElements();

    function showHideElements(){

        var $element =  $('.js-show-hide');

        $element.each(function(){
            toggleElements.call(this);
        });

        $element.on('change', function(){
            toggleElements.call(this);
        });

        function toggleElements() {
            var $this = $(this),
                $relatedElement = $('.'+$this.data('related'));

            if ($this.val() == 1) {
                $relatedElement.show();
            } else{
                $relatedElement.hide();
            }
        }

    };

}();